import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { graphql, compose, withApollo } from 'react-apollo'

import Typography from '@material-ui/core/Typography'

import axios from 'axios'
import imageCompression from 'browser-image-compression'

import { UPLOAD_DOCUMENT, REMOVE_DOCUMENT } from '../../../../graphql/mutations'
import { GET_USER_AUTHENTICATED } from '../../../../graphql/queries'

import { beforeUpload } from '../../../../utils'
import { withContext } from '../../../../context'
import { useDeepEffect } from '../../../../utils/hooks'
import { UploadWrapper, Wrapper, Preview, PreviewArea } from './styles'

export const Upload = ({
  name,
  label,
  me
}) => {
  const [imageUrl, setImageUrl] = useState('')
  const [avatarId, setAvatarId] = useState(0)
  const [heroData, setHeroData] = useState({})

  async function fetchData() {
    const res = await axios.get(
      process.env.REACT_APP_API_ENDPOINT + `/hero/detail/${me.id}`
    )
    setHeroData(res.data)
  }

  useDeepEffect(() => {
    fetchData()
  }, [])

  useDeepEffect(() => {
    setImageUrl(heroData.image)
  }, [heroData])
  const handleUpload = async (info) => {
    const formData = new FormData()
    const imageFile = info.target.files[0];
    try {
      const options = {
        maxSizeMB: 0.8,
        // maxWidthOrHeight: 256,
        useWebWorker: true
      }
      const compressedFile = await imageCompression(imageFile, options)
      formData.append('heroId', me.id)
      formData.append('image', compressedFile)
      const res = await axios.post(
        process.env.REACT_APP_API_ENDPOINT + `/hero/image-profile`,
        formData,
        {
          headers: {
            'content-type': 'multipart/form-data'
          }
        }
      )
      const { data } = res
      console.log(data)
      setAvatarId(data.heroId)
      setImageUrl(data.url)
      fetchData()
    } catch (err) {
      console.log(err)
    }
  }
  const btnId = `button-file-${name.replace(' ', '-')}`

  return (
    <UploadWrapper>
      <input
        style={{ display: 'none' }}
        accept="image/*"
        id={btnId}
        type="file"
        beforeUpload={beforeUpload}
        onChange={handleUpload}
      />
      <Wrapper>
        <label htmlFor={btnId} style={{ lineHeight: '20px' }}>
          <Typography variant="h6">{label}</Typography>
        </label>
      </Wrapper>
      {imageUrl ? (
        <label htmlFor={btnId}>
          <Preview>
            <img
              src={imageUrl}
              alt={avatarId}
              style={{ width: 'auto', height: '400px' }}

            />
          </Preview>
        </label>

      ) : (
        <label htmlFor={btnId}>
          <PreviewArea>
            <Typography color="primary">Click to upload</Typography>
          </PreviewArea>
        </label>
      )}
    </UploadWrapper>
  )
}

Upload.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  image: PropTypes.object.isRequired,
  context: PropTypes.object.isRequired,
  UploadDocument: PropTypes.func.isRequired,
  RemoveDocument: PropTypes.func.isRequired
}

export default compose(
  withContext,
  withApollo,
  graphql(UPLOAD_DOCUMENT, {
    name: 'UploadDocument',
    options: {
      refetchQueries: [{ query: GET_USER_AUTHENTICATED }]
    }
  }),
  graphql(REMOVE_DOCUMENT, {
    name: 'RemoveDocument',
    options: {
      refetchQueries: [{ query: GET_USER_AUTHENTICATED }]
    }
  })
)(Upload)



// WEBPACK FOOTER //
// ./src/components/HeroDocument/components/Upload/index.js